export default __webpack_public_path__ + "static/media/thumb-up.1a8c0b2a.svg";